const AUDIO_URL = '/m/tahoe_2025_mct'
const AUDIO_CONTAINER = 'webm'
const NUMBER_OF_CHUNKS = 239;
const DURATION = 1202;

let startAt: number | null = null;

interface AudioIndexRecord {
    t: number;
    o: number;
}

let audio = new Audio();
let audioSize: number;
const mediaSource = new MediaSource();
let sourceBuffer: SourceBuffer | null = null;
let nextChunk = 0;
let timestampOffset: number = 0;
let audioIndex: AudioIndexRecord[] | null = null
let startPlaybackTimout: NodeJS.Timeout | null = null;

async function fetchAndAppend() {
    if (nextChunk > NUMBER_OF_CHUNKS) {
        mediaSource.endOfStream();
        return;
    }

    const sf = Date.now();
    let data: ArrayBuffer | null = null;
    try {
        const resp = await fetch(`${AUDIO_URL}_${nextChunk.toString().padStart(3, '0')}.${AUDIO_CONTAINER}`);
        data = await resp.arrayBuffer();
    } catch (e) {
        alert('You went offline! You might need to refresh the page to resync with the show!');
    }
    const ef = Date.now();
    if (ef - sf > 4500) {
        alert('Your network is slow you might desynchronize from the show...');
    }

    // Wait if the buffer is updating
    if (sourceBuffer!.updating) {
        await new Promise(r =>
            sourceBuffer!.addEventListener('updateend', r, {once: true})
        );
    }
    const append = (data: ArrayBuffer) => {
        try {
            sourceBuffer!.appendBuffer(data);
        } catch (e) {
            if (e.name === 'QuotaExceededError') {
                setTimeout(() => append(data), 5000);
                console.debug()
                return;
            }

            console.error(audio.error);
            console.error(e);
        }
    }

    if (data !== null) {
        append(data);
        nextChunk++;
    }
}

const el = document.getElementById('playButton')
if (el !== null) {
    el.click();
    el.addEventListener("click", () => {
            if (audio.paused) {
                const now = Date.now();
                if (startAt != null) {
                    const offset = (now - startAt) / 1000;

                    if (offset < 0) {
                        const c = document.querySelector('#playButton > span');
                        if (c != null) {
                            c.innerHTML = '&#x23F8;'
                        }
                        if (startPlaybackTimout != null) {
                            return
                        }
                        startPlaybackTimout = setTimeout(() => {
                            audio.currentTime = 0;
                            audio.play().catch((err) => {
                                console.error('Failed to start the audio:', err);
                                audio.pause();
                                const c = document.querySelector('#playButton > span');
                                if (c != null) {
                                    c.innerHTML = '&#x23F5;'
                                }
                            });
                        }, startAt - Date.now());
                        alert('The show did not started yet. We will start playing when the time\'s right. 😏')
                    } else if (offset < DURATION) {
                        audio.currentTime = offset;
                        audio.play().catch((err) => {
                            console.error('Failed to start the audio:', err);
                        }).then(() => {
                            const c = document.querySelector('#playButton > span');
                            if (c != null) {
                                c.innerHTML = '&#x23F8;'
                            }
                        });
                    } else if (offset > DURATION) {
                        alert('It looks like the show is over... 😒');
                    }
                } else {
                    audio.currentTime = 0;
                    audio.play().catch((err) => {
                        console.error('Failed to start the audio:', err);
                    }).then(() => {
                        const c = document.querySelector('#playButton > span');
                        if (c != null) {
                            c.innerHTML = '&#x23F8;'
                        }
                    });
                }
            } else {
                audio.pause();
                const c = document.querySelector('#playButton > span');
                if (c != null) {
                    c.innerHTML = '&#x23F5;'
                }
                if (startPlaybackTimout != null) {
                    clearTimeout(startPlaybackTimout);
                    startPlaybackTimout = null;
                }
            }
        }
    )
    ;
}

window.onload = async () => {
    const playButton = document.getElementById('playButton')
    if (playButton !== null) {
        playButton.style.display = 'none';
    }

    const params = new URLSearchParams(window.location.search);
    const timestampString = params.get('t');
    if (timestampString == null) {
        startAt = null;
    } else if (!isNaN(Number(timestampString))) {
        startAt = parseInt(timestampString)
    } else {
        startAt = new Date(timestampString).getTime();
    }

    setTimeout(() => {
        if (playButton != null) {
            playButton.style.display = 'block';
        }
    }, 5 * 1000);

    console.debug('Current timestamp for reference: ', Date.now());
    console.debug('60 seconds in te future timestamp for reference: ', Date.now() + 60000);
    console.debug('The audio should start at: ', startAt);

    mediaSource.addEventListener('sourceopen', async () => {
        URL.revokeObjectURL(audio.src);
        sourceBuffer = mediaSource.addSourceBuffer('audio/webm; codecs="vorbis"');

        const audioHeaderResponse = await fetch(`${AUDIO_URL}.${AUDIO_CONTAINER}`);
        const audioHeader = await audioHeaderResponse.arrayBuffer();

        nextChunk = startAt != null ? Math.max(0, Math.floor(((Date.now() + 5 * 1000 - startAt) / 1000) / 5)) : 0;

        sourceBuffer.appendBuffer(audioHeader);
        if (sourceBuffer.updating) {
            await new Promise(r =>
                sourceBuffer!.addEventListener('updateend', r, {once: true})
            );
        }

        sourceBuffer.addEventListener('updateend', fetchAndAppend);
        await fetchAndAppend();
    });
    audio.src = URL.createObjectURL(mediaSource);
    audio.preload = 'auto';

    setInterval(() => console.debug('Current audio position: ', audio.currentTime), 1000);
    gameLoop()
}


//   FIREWORKS EFFECT

// Local variables
var fireworks = [];
var particles = [];
var mouse = {down: false, x: 0, y: 0};
var currentHue = 120;
var clickLimiterTotal = 80;
var clickLimiterTick = 0;
var timerTotal = 30;
var timerTick = 0;

// Helper function for canvas animations
window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function (cb) {
            window.setTimeout(callback, 1000 / 60);
        }
})();

// Helper function to return random numbers within a specified range
function random(min, max) {
    return Math.random() * (max - min) + min;
}

// Helper function to calculate the distance between 2 points
function calculateDistance(p1x, p1y, p2x, p2y) {
    var xDistance = p1x - p2x;
    var yDistance = p1y - p2y;
    return Math.sqrt(Math.pow(xDistance, 2) + Math.pow(yDistance, 2));
}

// Setup some basic variables
var canvas = document.getElementById('canvas');
var canvasCtx = canvas.getContext('2d');
var canvasWidth = window.innerWidth;
var canvasHeight = window.innerHeight;

// Resize canvas
canvas.width = canvasWidth;
canvas.height = canvasHeight;

// Firework class
function Firework(sx, sy, tx, ty) {
    // Set coordinates (x/y = actual, sx/sy = starting, tx/ty = target)
    this.x = this.sx = sx;
    this.y = this.sy = sy;
    this.tx = tx;
    this.ty = ty;

    // Calculate distance between starting and target point
    this.distanceToTarget = calculateDistance(sx, sy, tx, ty);
    this.distanceTraveled = 0;

    // To simulate a trail effect, the last few coordinates will be stored
    this.coordinates = [];
    this.coordinateCount = 3;

    // Populate coordinate array with initial data
    while (this.coordinateCount--) {
        this.coordinates.push([this.x, this.y]);
    }

    // Some settings, you can adjust them if you'd like to do so.
    this.angle = Math.atan2(ty - sy, tx - sx);
    this.speed = 2;
    this.acceleration = 1.03;
    this.brightness = random(50, 80);
    this.targetRadius = 1;
    this.targetDirection = false;  // false = Radius is getting bigger, true = Radius is getting smaller
};

// This method should be called each frame to update the firework
Firework.prototype.update = function (index) {
    // Update the coordinates array
    this.coordinates.pop();
    this.coordinates.unshift([this.x, this.y]);

    // Cycle the target radius (used for the pulsing target circle)
    // if (!this.targetDirection) {
    //     if (this.targetRadius < 8)
    //         this.targetRadius += 0.15;
    //     else
    //         this.targetDirection = true;
    // } else {
    //     if (this.targetRadius > 1)
    //         this.targetRadius -= 0.15;
    //     else
    //         this.targetDirection = false;
    // }

    // Speed up the firework (could possibly travel faster than the speed of light)
    this.speed *= this.acceleration;

    // Calculate the distance the firework has travelled so far (based on velocities)
    var vx = Math.cos(this.angle) * this.speed;
    var vy = Math.sin(this.angle) * this.speed;
    this.distanceTraveled = calculateDistance(this.sx, this.sy, this.x + vx, this.y + vy);

    // If the distance traveled (including velocities) is greater than the initial distance
    // to the target, then the target has been reached. If that's not the case, keep traveling.
    if (this.distanceTraveled >= this.distanceToTarget) {
        createParticles(this.tx, this.ty);
        fireworks.splice(index, 1);
    } else {
        this.x += vx;
        this.y += vy;
    }
};

// Draws the firework
Firework.prototype.draw = function () {
    var lastCoordinate = this.coordinates[this.coordinates.length - 1];

    // Draw the rocket
    canvasCtx.beginPath();
    canvasCtx.moveTo(lastCoordinate[0], lastCoordinate[1]);
    canvasCtx.lineTo(this.x, this.y);
    canvasCtx.strokeStyle = 'hsl(' + currentHue + ',100%,' + this.brightness + '%)';
    canvasCtx.stroke();

    // Draw the target (pulsing circle)
    // canvasCtx.beginPath();
    // canvasCtx.arc(this.tx, this.ty, this.targetRadius, 0, Math.PI * 2);
    // canvasCtx.stroke();
};

// Particle class
function Particle(x, y) {
    // Set the starting point
    this.x = x;
    this.y = y;

    // To simulate a trail effect, the last few coordinates will be stored
    this.coordinates = [];
    this.coordinateCount = 5;

    // Populate coordinate array with initial data
    while (this.coordinateCount--) {
        this.coordinates.push([this.x, this.y]);
    }

    // Set a random angle in all possible directions (radians)
    this.angle = random(0, Math.PI * 2);
    this.speed = random(1, 10);

    // Add some friction and gravity to the particle
    this.friction = 0.95;
    this.gravity = 1;

    // Change the hue to a random number
    this.hue = random(currentHue - 20, currentHue + 20);
    this.brightness = random(50, 80);
    this.alpha = 1;

    // Set how fast the particles decay
    this.decay = random(0.01, 0.03);
}

// Updates the particle, should be called each frame
Particle.prototype.update = function (index) {
    // Update the coordinates array
    this.coordinates.pop();
    this.coordinates.unshift([this.x, this.y]);

    // Slow it down (based on friction)
    this.speed *= this.friction;

    // Apply velocity to the particle
    this.x += Math.cos(this.angle) * this.speed;
    this.y += Math.sin(this.angle) * this.speed + this.gravity;

    // Fade out the particle, and remove it if alpha is low enough
    this.alpha -= this.decay;
    if (this.alpha <= this.decay) {
        particles.splice(index, 1);
    }
}

// Draws the particle
Particle.prototype.draw = function () {
    var lastCoordinate = this.coordinates[this.coordinates.length - 1];

    canvasCtx.beginPath();
    canvasCtx.moveTo(lastCoordinate[0], lastCoordinate[1]);
    canvasCtx.lineTo(this.x, this.y);
    canvasCtx.strokeStyle = 'hsla(' + this.hue + ',100%,' + this.brightness + '%,' + this.alpha + ')';
    canvasCtx.stroke();
}

// Create a bunch of particles at the given position
function createParticles(x, y) {
    var particleCount = 30;
    while (particleCount--) {
        particles.push(new Particle(x, y));
    }
}

// Add an event listener to the window so we're able to react to size changes
window.addEventListener('resize', function (e) {
    canvas.width = canvasWidth = window.innerWidth;
    canvas.height = canvasHeight = window.innerHeight;
});

// Add event listeners to the canvas to handle mouse interactions
canvas.addEventListener('mousemove', function (e) {
    e.preventDefault();
    mouse.x = e.pageX - canvas.offsetLeft;
    mouse.y = e.pageY - canvas.offsetTop;
});

canvas.addEventListener('mousedown', function (e) {
    e.preventDefault();
    mouse.down = true;
});

canvas.addEventListener('mouseup', function (e) {
    e.preventDefault();
    mouse.down = false;
});

// Main application / script, called when the window is loaded
function gameLoop() {
    // This function will rund endlessly by using requestAnimationFrame (or fallback to setInterval)
    requestAnimFrame(gameLoop);

    // Increase the hue to get different colored fireworks over time
    currentHue += 0.5;

    // 'Clear' the canvas at a specific opacity, by using 'destination-out'. This will create a trailing effect.
    canvasCtx.globalCompositeOperation = 'destination-out';
    canvasCtx.fillStyle = 'rgba(0, 0, 0, 0.5)';
    canvasCtx.fillRect(0, 0, canvasWidth, canvasHeight);
    canvasCtx.globalCompositeOperation = 'lighter';

    // Loop over all existing fireworks (they should be updated & drawn)
    var i = fireworks.length;
    while (i--) {
        fireworks[i].draw();
        fireworks[i].update(i);
    }

    // Loop over all existing particles (they should be updated & drawn)
    var i = particles.length;
    while (i--) {
        particles[i].draw();
        particles[i].update(i);
    }

    // Launch fireworks automatically to random coordinates, if the user does not interact with the scene
    if (timerTick >= timerTotal) {
        if (!mouse.down) {
            if (!audio.paused)
                fireworks.push(new Firework(canvasWidth / 2, canvasHeight * .8, random(0, canvasWidth), random(0, canvasHeight / 2)));
            timerTick = 0;
        }
    } else {
        timerTick++;
    }

    // Limit the rate at which fireworks can be spawned by mouse
    if (clickLimiterTick >= clickLimiterTotal) {
        if (mouse.down) {
            if (!audio.paused)
                fireworks.push(new Firework(canvasWidth / 2, canvasHeight * .8, mouse.x, mouse.y));
            clickLimiterTick = 0;
        }
    } else {
        clickLimiterTick++;
    }
}